import useLanguage from '../../../../hooks/useLanguage';
import { useEpgLocalization } from '../useEpgLocalization';

export const usePpvEvent = (channel, selectedProgram) => {
    const lang = useLanguage();
    const {
        isPPV: programIsPPV,
        ppvEvent,
        isPPVPurchased,
        ppvEventId,
        ppvPrice,
        ppvCurrency,
        title,
        localizedTitle,
        description,
        localizedDescription,
    } = selectedProgram || {};

    const localization = useEpgLocalization();

    // Fallback PPV detection if program-level PPV data is missing
    // Check if this is a PPV channel and program-level PPV data is incomplete
    const channelIsPPV = channel?.isPPV || channel?.subscriptions?.[0]?.subscriptionGUID?.includes('PPV');
    const isPPV = programIsPPV || channelIsPPV;

    // If PPV data is missing from program but channel is PPV, provide defaults
    const hasIncompletePPVData = isPPV && !ppvEvent && !ppvEventId;
    const effectivePPVEventId = ppvEventId || (hasIncompletePPVData ? selectedProgram?.ppvEventId : null);
    const effectivePPVPrice = ppvPrice || (hasIncompletePPVData ? selectedProgram?.ppvPrice : null);
    const effectivePPVCurrency = ppvCurrency || (hasIncompletePPVData ? selectedProgram?.ppvCurrency : null);
    const effectiveIsPPVPurchased = isPPVPurchased !== undefined ? isPPVPurchased : false;
    const displayTitle = lang === 'en' ? title : localizedTitle?.ar;
    const displayDescription = lang === 'en' ? description : localizedDescription?.ar;

    let ppv_description_text = '';
    if (ppvEvent?.eventExpiryDate) {
        const expiryDate = new Date(ppvEvent?.eventExpiryDate);
        const currentDate = new Date();
        const timeDifference = expiryDate.getTime() - currentDate.getTime();
        const daysDifference = Math.ceil(timeDifference / (1000 * 3600 * 24));

        if (daysDifference > 0) {
            // Use translations for the message and days
            const contentAvailableLabel = localization?.ppv_content_available || 'Content will be available';
            const daysLabel = daysDifference > 1 ? localization?.ppv_days || 'Days' : localization?.ppv_day || 'Day';

            ppv_description_text = `${contentAvailableLabel}: ${daysDifference} ${daysLabel}`;
        } else {
            ppv_description_text = localization?.ppv_available_soon || 'Soon';
        }
    } else {
        ppv_description_text = localization?.ppv_available_soon || 'Soon';
    }

    return {
        displayTitle,
        displayDescription,
        effectiveIsPPVPurchased,
        effectivePPVEventId,
        effectivePPVPrice,
        effectivePPVCurrency,
        ppv_description_text,
    };
};
